(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
        const dropdowns = document.querySelectorAll('.custom-dropdown');

        dropdowns.forEach((dropdown) => {
            const header = dropdown.querySelector('.dropdown-header');

            header.addEventListener('click', () => {
                // Close other dropdowns
                dropdowns.forEach((d) => {
                    if (d !== dropdown) {
                        d.classList.remove('active');
                    }
                });
                // Toggle this dropdown
                dropdown.classList.toggle('active');
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            dropdowns.forEach((dropdown) => {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove('active');
                }
            });
        });
    });
  } catch(e) { console.error(e); }
})();

})();
